import { render, staticRenderFns } from "./AskContainer.vue?vue&type=template&id=7ca20342&scoped=true"
import script from "./AskContainer.vue?vue&type=script&lang=js"
export * from "./AskContainer.vue?vue&type=script&lang=js"
import style0 from "./AskContainer.vue?vue&type=style&index=0&id=7ca20342&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca20342",
  null
  
)

export default component.exports